import Trailer from '@/types/Trailer';
import { isNullOrUndefined } from '@/shared/helpers';

export const hasIdentifyingValue = (val: string | undefined): boolean => {
    const trimmedVal = val?.trim();

    return (
        !isNullOrUndefined(trimmedVal) &&
        trimmedVal !== '' &&
        trimmedVal?.toUpperCase() !== 'NA'
    );
};

export const trailerHasVin = (trailer: Trailer | undefined): boolean => {
    return hasIdentifyingValue(trailer?.vehicleIdentificationNumber);
};

export const trailerHasLicensePlateNumber = (
    trailer: Trailer | undefined
): boolean => {
    return hasIdentifyingValue(trailer?.licensePlateNumber);
};

export const vinOrPlateVerificationText = (
    hasVin: boolean,
    hasLicensePlateNumber: boolean
): string => {
    if (hasVin && !hasLicensePlateNumber) {
        return '<strong>last 6 digits</strong> of the VIN';
    } else if (hasLicensePlateNumber && !hasVin) {
        return '<strong>plate number</strong>';
    }
    return '<strong>plate number</strong> or the <strong>last 6 digits</strong> of the VIN';
};

export const isVinMatch = (
    trailer: Trailer | undefined,
    vin: string
): boolean => {
    if (vin === '') {
        return false;
    }

    const last6 = trailer?.vehicleIdentificationNumber
        ?.trim()
        .toUpperCase()
        .slice(-6);

    return vin.toUpperCase() === last6;
};

export const isPlateMatch = (
    trailer: Trailer | undefined,
    licensePlate: string
): boolean => {
    if (licensePlate === '') {
        return false;
    }

    return (
        licensePlate.toUpperCase() ===
        trailer?.licensePlateNumber?.trim().toUpperCase()
    );
};
